import { Box, Stack } from '@chakra-ui/react';
import { TextExt } from '@time-line/components/common';
import { ProductCard } from 'components/product/ProductCard';
import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useImage } from 'lib/sanity';
import Image from 'next/image';
import type { FeaturedProduct as FeaturedProductProps } from 'types/cms/pages/ProductListingPage';

export function FeaturedProduct({
  image,
  description,
  product,
}: FeaturedProductProps) {
  const imageProps = useImage(image, { ratio: 4 / 5 });
  const sanityProduct = useSanityProduct(product.slug);

  return (
    <>
      <Box display={{ lg: 'none' }} gridColumn="span 12">
        <TextExt size="h4-serif">{description}</TextExt>
      </Box>
      <Box
        gridColumn={{ base: 'span 6', md: 'span 4', lg: 'span 5' }}
        order={{ base: 2, lg: 1 }}
      >
        {imageProps && (
          <Box borderRadius="base" overflow="hidden">
            <Image {...imageProps} />
          </Box>
        )}
      </Box>
      <Stack
        order={{ base: 1, lg: 2 }}
        gridColumn={{ base: 'span 6', md: 'span 4', lg: '7 / span 3' }}
        justify="space-between"
        gap="sm"
      >
        <TextExt display={{ base: 'none', lg: 'block' }} size="h4-serif">
          {description}
        </TextExt>
        {sanityProduct && (
          <Box>
            <ProductCard
              index={0}
              collectionName="PLP featured product"
              isATCVisible
              {...sanityProduct}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}
